import React from "react";

export default function BookingIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      fill="none"
      viewBox="0 0 39 38"
    >
      <path
        fill="currentColor"
        d="M23.063 0c.655 0 1.187.532 1.187 1.188 0 .655.532 1.187 1.188 1.187.655 0 1.187.532 1.187 1.188V4.75c0 .656-.532 1.188-1.188 1.188H13.563a1.188 1.188 0 0 1-1.187-1.188V3.562c0-.655.532-1.187 1.188-1.187.655 0 1.187-.532 1.187-1.188C14.75.532 15.282 0 15.938 0h7.124Z"
      />
      <path
        fill="currentColor"
        d="M7.625 5.938c0-.656.532-1.188 1.188-1.188H10a1.188 1.188 0 0 0 0-2.375H8.812A3.563 3.563 0 0 0 5.25 5.938v28.5A3.563 3.563 0 0 0 8.813 38h21.374a3.563 3.563 0 0 0 3.563-3.563v-28.5a3.563 3.563 0 0 0-3.563-3.562H29a1.188 1.188 0 0 0 0 2.375h1.188c.655 0 1.187.532 1.187 1.188v28.5c0 .655-.532 1.187-1.188 1.187H8.813a1.188 1.188 0 0 1-1.187-1.188v-28.5Z"
      />
      <path
        fill="currentColor"
        d="M26.277 18.652a1.188 1.188 0 0 0-1.68-1.68l-6.285 6.286-2.722-2.723a1.188 1.188 0 0 0-1.68 1.68l3.563 3.562a1.188 1.188 0 0 0 1.68 0l7.124-7.125Z"
      />
    </svg>
  );
}
